export async function GetToken(opts) {
    if (!opts.authUser || !opts.authPassword) {
        const missingParams = ['authUser', 'authPassword']
            .filter(param => !opts[param])
            .join(', ');
        return {
            error: {
                details: `Missing authentication parameters for [${opts.name}]. Check the following properties in the GIS configuration file: ${missingParams}`
            }
        };
    }
    let authUrl = deriveAuthUrl(opts);
    const serialize = (obj) => {
        let strs = [];
        for (let p in obj) {
            if (obj.hasOwnProperty(p)) {
                strs.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }
        return strs.join('&');
    };
    try {
        const response = await fetch(authUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json'
            },
            redirect: 'follow',
            body: serialize({ username: opts.authUser, password: opts.authPassword, f: 'json' }),
        });
        let returned_obj = await response.json();
        let token_err = returned_obj;
        if (token_err.error) {
            return {
                error: {
                    details: "Failed to retrieve the token for [" + opts.name + "]. Reason: [" + token_err.error.details + "]"
                }
            };
        }
        else {
            return returned_obj;
        }
    }
    catch (error) {
        return {
            error: {
                details: `Error fetching token: ${error}`
            }
        };
    }
}
function deriveAuthUrl(opts) {
    let serviceUrl = Array.isArray(opts.serviceUrl) ? opts.serviceUrl[0] : opts.serviceUrl;
    try {
        let url = new URL(serviceUrl);
        let host = url.host;
        let protocol = url.protocol;
        const authPath = 'arcgis/tokens/';
        let authUrl = new URL(`${authPath}`, `${protocol}//${host}`).href;
        return authUrl;
    }
    catch (ex) {
        const err = `Could not parse "${serviceUrl}" as a URL. Check the "URL" property  for "${opts.name}" in the GIS configuration file.`;
        console.error(err);
        return '';
    }
}
